import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  general: Yup.object().shape({
    name: Yup.string().nullable().required('Commodity Name is required'),
    type: Yup.string().nullable().required('Commodity Type is required'),
    code: Yup.string().nullable().required('Commodity Code is required'),
  }),
  weightThreshold: Yup.object().shape({
    enabled: Yup.boolean(),
    amount: Yup.number().when(['enabled'], {
      is: true,
      then: Yup.number()
        .typeError('A number is required')
        .positive('Value must be a positive number')
        .moreThan(0, 'Value must be greater than zero')
        .required('A value is required.'),
    }),
  }),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
